import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/utils/angular-material';
import { InterceptorComponent } from './interceptor/interceptor/interceptor.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TemplateComponent } from './components/template/template.component';
import { ConfirmDialogComponent } from './shared-components/confirm-dialog/confirm-dialog.component';
import { LogoutComponent } from './components/logout/logout.component';
import { HomeComponent } from './components/home/home.component';

import { LandingpageoutsideloginComponent } from './components/landingpageoutsidelogin/landingpageoutsidelogin.component';
import { AdminComponent } from './components/admin/admin.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';

import { AgGridModule } from 'ag-grid-angular';
import { ToggledependencyComponent } from './components/toggledependency/toggledependency.component';
import { EditbuttonrenderComponent } from './components/editbuttonrender/editbuttonrender.component';
import { DefinedoctypeComponent } from './components/definedoctype/definedoctype.component';
import { UploaddocComponent } from './components/uploaddoc/uploaddoc.component';
import { TenantmanagementComponent } from './components/tenantmanagement/tenantmanagement.component';
import { DynamicpopupComponent } from './components/dynamicpopup/dynamicpopup.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PopupimmudbcontentComponent } from './components/popupimmudbcontent/popupimmudbcontent.component';
import { HtmlcontentimmudbComponent } from './components/htmlcontentimmudb/htmlcontentimmudb.component';
import { BrowserCompatablityComponent } from './components/browser-compatablity/browser-compatablity.component';
import { SentmailwithdetailsComponent } from './components/sentmailwithdetails/sentmailwithdetails.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { UsersComponent } from './components/users/users.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    TemplateComponent,
    ConfirmDialogComponent,
    LogoutComponent,
    HomeComponent,
    LandingpageoutsideloginComponent,
    AdminComponent,
    DocumentsComponent,
    ToggledependencyComponent,
    EditbuttonrenderComponent,
    DefinedoctypeComponent,
    UploaddocComponent,
    TenantmanagementComponent,
    DynamicpopupComponent,
    PopupimmudbcontentComponent,
    HtmlcontentimmudbComponent,
    BrowserCompatablityComponent,
    SentmailwithdetailsComponent,
    LandingPageComponent,
    UsersComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatSelectFilterModule,
    AgGridModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PdfViewerModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: InterceptorComponent, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
